module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"smsLeft":"Осталось SMS","smsQuotaExceeded":"Недостаточно SMS для отправки","changePlan":"Изменить тариф"}}')
  delete Component.options._Ctor
}
